import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "@/components/ScrollToTop";
import ScrollToTopButton from "@/components/ScrollToTopButton";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Templates from "./pages/Templates";
import FormBuilder from "./pages/FormBuilder";
import FormPublic from "./pages/FormPublic";
import FormResult from "./pages/FormResult";
import Upgrade from "./pages/Upgrade";
import ManageSubscription from "./pages/ManageSubscription";
import ClaimGift from "./pages/ClaimGift";
import Admin from "./pages/Admin";
import AdminTemplates from "./pages/AdminTemplates";
import AdminCosts from "./pages/AdminCosts";
import AdminFinancial from "./pages/AdminFinancial";
import Blog from "./pages/Blog";
import BlogPostCapturaLeads from "./pages/blog/BlogPostCapturaLeads";
import BlogPostLeadMagnets from "./pages/blog/BlogPostLeadMagnets";
import BlogPostPDFsQueVendem from "./pages/blog/BlogPostPDFsQueVendem";
import BlogPostFunilVendas from "./pages/blog/BlogPostFunilVendas";
import BlogPostIAQualificacao from "./pages/blog/BlogPostIAQualificacao";
import BlogPostMelhorFerramenta from "./pages/blog/BlogPostMelhorFerramenta";
import BlogPostCustoNaoAutomatizar from "./pages/blog/BlogPostCustoNaoAutomatizar";
import BlogPostLandingPagesConvertem from "./pages/blog/BlogPostLandingPagesConvertem";
import BlogPostDiagnosticoIA from "./pages/blog/BlogPostDiagnosticoIA";
import BlogPostFormulariosDinamicos from "./pages/blog/BlogPostFormulariosDinamicos";
import BlogPostFormularioCapturaLeads from "./pages/blog/BlogPostFormularioCapturaLeads";
import BlogPostAtencaoSemAnuncios from "./pages/blog/BlogPostAtencaoSemAnuncios";
import BlogPostQuizQualificaLeads from "./pages/blog/BlogPostQuizQualificaLeads";
import Privacidade from "./pages/legal/Privacidade";
import TermosDeUso from "./pages/legal/TermosDeUso";
import LGPD from "./pages/legal/LGPD";
import PoliticaReembolso from "./pages/legal/PoliticaReembolso";
import ResetPassword from "./pages/ResetPassword";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <ScrollToTopButton />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/form-builder" element={<FormBuilder />} />
            <Route path="/form-builder/:formId" element={<FormBuilder />} />
            <Route path="/f/:slug" element={<FormPublic />} />
            <Route path="/f/:slug/resultado" element={<FormResult />} />
            <Route path="/upgrade" element={<Upgrade />} />
            <Route path="/manage-subscription" element={<ManageSubscription />} />
            <Route path="/presente" element={<ClaimGift />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/templates" element={<AdminTemplates />} />
            <Route path="/admin/costs" element={<AdminCosts />} />
            <Route path="/admin/financial" element={<AdminFinancial />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/como-aplicar-estrategias-captura-de-leads" element={<BlogPostCapturaLeads />} />
            <Route path="/blog/os-10-melhores-lead-magnets-que-convertem" element={<BlogPostLeadMagnets />} />
            <Route path="/blog/como-criar-pdfs-que-vendem" element={<BlogPostPDFsQueVendem />} />
            <Route path="/blog/funil-de-vendas-black-friday-2025" element={<BlogPostFunilVendas />} />
            <Route path="/blog/ia-para-qualificacao-de-leads" element={<BlogPostIAQualificacao />} />
            <Route path="/blog/melhor-ferramenta-de-formulario-para-seu-negocio" element={<BlogPostMelhorFerramenta />} />
            <Route path="/blog/quanto-custa-nao-automatizar-sua-empresa" element={<BlogPostCustoNaoAutomatizar />} />
            <Route path="/blog/landing-pages-que-convertem-em-2026" element={<BlogPostLandingPagesConvertem />} />
            <Route path="/blog/diagnostico-com-ia-para-consultores-capturar-leads" element={<BlogPostDiagnosticoIA />} />
            <Route path="/blog/como-criar-formularios-dinamicos-que-convertem" element={<BlogPostFormulariosDinamicos />} />
            <Route path="/blog/como-criar-formulario-de-captura-de-leads-que-converte" element={<BlogPostFormularioCapturaLeads />} />
            <Route path="/blog/como-conquistar-atencao-sem-gastar-mais-em-anuncios" element={<BlogPostAtencaoSemAnuncios />} />
            <Route path="/blog/como-criar-quiz-que-qualifica-leads-automaticamente" element={<BlogPostQuizQualificaLeads />} />
            <Route path="/privacidade" element={<Privacidade />} />
            <Route path="/termos-de-uso" element={<TermosDeUso />} />
            <Route path="/lgpd" element={<LGPD />} />
            <Route path="/politica-de-reembolso" element={<PoliticaReembolso />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
